import { Link, useLocation, useNavigate } from "react-router-dom";
import { Compass, LogOut, Bookmark, Sparkles, Inbox } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  if (!user) return null;

  const linkCls = (path) =>
    `nb-badge bg-white ${loc.pathname === path ? "bg-brand-yellow" : "bg-white"}`;

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-brand-bg border-b-2 border-black">
      <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/assessment" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="bg-brand-primary border-2 border-black rounded-lg p-1.5 shadow-nb-xs">
            <Compass className="w-5 h-5 text-white" />
          </div>
          <span className="font-heading text-xl font-bold text-black">TalentSwipe<span className="text-brand-primary">.us</span></span>
        </Link>
        <nav className="flex items-center gap-2 md:gap-3">
          <Link to="/assessment" data-testid="nav-assessment" className={linkCls("/assessment")}>
            <Sparkles className="w-4 h-4" /> <span className="hidden sm:inline">Swipe</span>
          </Link>
          <Link to="/results" data-testid="nav-results" className={linkCls("/results")}>
            <Compass className="w-4 h-4" /> <span className="hidden sm:inline">Matches</span>
          </Link>
          <Link to="/saved" data-testid="nav-saved" className={linkCls("/saved")}>
            <Bookmark className="w-4 h-4" /> <span className="hidden sm:inline">Saved</span>
          </Link>
          {user.role === "admin" && (
            <Link to="/admin/leads" data-testid="nav-admin-leads" className={linkCls("/admin/leads")}>
              <Inbox className="w-4 h-4" /> <span className="hidden sm:inline">Leads</span>
            </Link>
          )}
          <button
            data-testid="nav-logout"
            onClick={handleLogout}
            className="nb-badge bg-brand-purple"
            title="Log out"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </nav>
      </div>
    </header>
  );
}
